import React, { useState } from 'react';

const steps = [
    {
        icon: '🔍',
        title: 'Search',
        text: 'Use the search bar to find any song instantly by title, artist, or 3-digit song number (e.g. 001).',
    },
    {
        icon: '📂',
        title: 'Browse Categories',
        text: 'Click the ☰ menu on the left to open the sidebar and browse all liturgical song categories.',
    },
    {
        icon: '▶️',
        title: 'Play a Song',
        text: 'Click any song row to open and play it directly on YouTube in a new tab.',
    },
    {
        icon: '📄',
        title: 'Song Numbers',
        text: 'Each song has a 3-digit number. Use this number to search quickly. E.g. "042" or "100".',
    },
    {
        icon: '📱',
        title: 'Mobile Friendly',
        text: 'The app works perfectly on phones & tablets. Use the ☰ button on the top-left to open the menu.',
    },
    {
        icon: '🔗',
        title: 'Share a Song',
        text: 'Open any song on YouTube and use the YouTube share button to share with friends and family.',
    },
];

const HelpButton = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            {/* Floating Help FAB — always visible on the right */}
            <button
                id="help-fab-btn"
                className="help-fab"
                onClick={() => setOpen(true)}
                aria-label="Help"
                title="How to use Idhaya Ragam"
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <circle cx="12" cy="17" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="1.5" />
                </svg>
                <span className="help-fab-label">Help</span>
            </button>

            {/* Help Drawer Overlay */}
            {open && (
                <div className="help-overlay" onClick={() => setOpen(false)}>
                    <div
                        className="help-drawer"
                        onClick={(e) => e.stopPropagation()}
                        role="dialog"
                        aria-modal="true"
                        aria-label="How to use guide"
                    >
                        {/* Close button */}
                        <button className="help-drawer-close" onClick={() => setOpen(false)} aria-label="Close help">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                            </svg>
                        </button>

                        {/* Header */}
                        <div className="help-drawer-header">
                            <div className="help-drawer-icon">
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    <circle cx="12" cy="17" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="1.5" />
                                </svg>
                            </div>
                            <h2 className="help-drawer-title">How to Use</h2>
                            <p className="help-drawer-subtitle">
                                Idhaya Ragam — Christian Catholic Tamil Songs
                            </p>
                        </div>

                        {/* Steps */}
                        <div className="help-steps">
                            {steps.map((step, i) => (
                                <div className="help-step" key={i}>
                                    <div className="help-step-num">{i + 1}</div>
                                    <div className="help-step-icon">{step.icon}</div>
                                    <div className="help-step-content">
                                        <h4 className="help-step-title">{step.title}</h4>
                                        <p className="help-step-text">{step.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Footer */}
                        <div className="help-drawer-footer">
                            <div className="help-footer-cross">✝</div>
                            <p>May these songs bring you closer to God 🙏</p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default HelpButton;
